export const PAGE_LOAD_DELAY_MS = 150
